module.exports = __webpack_public_path__ + "img/logo.052912ac.jpg";